
import React from 'react';
import PropTypes from 'prop-types';
import { isNil, isEmpty } from "lodash";

// Material UI Components
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogOkCancel = ({ ...props }) => {
    const { open, title, actions, okLabel, okButton, cancelLabel, onOk, onCancel, ...others } = props;

    // const renders = useRef(0);

    const hasCancel = !isNil(props.onCancel)
    let cancelLabelLocal = isEmpty(cancelLabel) ? "Cancelar" : cancelLabel;
    let okLabelLocal = isEmpty(okLabel) ? (!hasCancel ? "Entendido" : "Aceptar") : okLabel;

    const handleOnExited = () => {
        if (props.onExited) {
            props.onExited();
        }
    }

    return (
        <>
            {/* {console.log(renders.current++)} */}
            {/* {!isNil(props.msg) && */}
            <Dialog
                open={open}
                TransitionComponent={Transition}
                TransitionProps={{
                    onExited: handleOnExited
                }}
                {...others}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText component="div">
                        {props.msg}
                    </DialogContentText>
                    {props.children}
                </DialogContent>
                <DialogActions>
                    {actions}
                    {hasCancel &&
                        <Button onClick={onCancel} color="primary">
                            {cancelLabelLocal}
                        </Button>
                    }
                    {!isNil(okButton) ?
                        okButton
                        :
                        <Button onClick={onOk} color="primary">
                            {okLabelLocal}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
            {/* } */}
        </>
    )
};

DialogOkCancel.propTypes = {
    onCancel: PropTypes.func,
    onExit: PropTypes.func,
    onOk: PropTypes.func,
    open: PropTypes.bool,
    msg: PropTypes.node,
    okLabel: PropTypes.node,
    cancelLabel: PropTypes.node,
    okButton: PropTypes.node,
    title: PropTypes.node,
};

DialogOkCancel.defaultProps = {
    title: 'Atención',
    keepMounted: false,
}

DialogOkCancel.displayName = 'DialogOkCancel';

export default React.memo(DialogOkCancel);